import { Inject, Injectable } from "@angular/core";

import { IConfig } from "@shared/interfaces";
import { APP_CONFIG } from "@shared/tokens";
import { CommonUtils } from "@shared/utils";

@Injectable({
  providedIn: "root",
})
export class GoogleAnalyticsService {
  constructor(@Inject(APP_CONFIG) private environment: IConfig) {
    if (!this.environment.googleAnalyticsId) {
      return;
    }
    this.initializeAnalytics();
  }

  trackPageView(path: string): void {
    if (!this.environment.googleAnalyticsId) {
      return;
    }

    window.gtag("config", this.environment.googleAnalyticsId, {
      page_path: path,
    });
  }

  private initializeAnalytics(): void {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (..._args: any[]) {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };

    CommonUtils.loadScripts([
      {
        source: `https://www.googletagmanager.com/gtag/js?id=${this.environment.googleAnalyticsId}`,
        async: true,
      },
    ]);

    window.gtag("js", new Date());
    window.gtag("config", this.environment.googleAnalyticsId);
  }
}
